import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/GenericServices/RespondentTransportationServiceGS.css';
import cancelicon from '../../../Assets/TruckVisits/Assets-Desktop/cancel-icon.svg';
import info_outline from '../../../Assets/UserAccess/Desktop/info-outline.svg';
import DropDownTable from '../../Shared/DropDownTable';
import StarRatingModal from "../../Shared/StarRatingModal";
import GenericReusableModal from '../../Shared/GenericReusableModal';
import alertIcon from '../../../Assets/ContainerStatus/Assets_Desktop/alert.svg';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import Input from '../../Shared/Input';
import CancelModal from '../../Shared/CancelModalMarketPlace';
import AlreadyBidModal from '../../Shared/GenericModalError';
import UploadFile from '../../Shared/UploadFile';
import Button from '../../Shared/Button';
import pickupTime from '../../../Assets/NominateRequest/pickupTime.svg';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import bigBlankStar from '../../../Assets/NominateRequest/starBlank_large.svg';
import bigFilledStar from '../../../Assets/NominateRequest/starFilled_large.svg';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import Message from '../../../Data/Shared/Message.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import SuccessModal from '../../Shared/SuccessModal';
import ViewServiceDetailsGS from './ViewServiceDetailsGS';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_REQUEST_ENDPOINT, SERVICE_BIDQUOTE_ENDPOINT, SERVICE_CANCELLATION_POLICY_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { connect } from 'react-redux';
class RespondentTransportationServiceGS extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            serviceRequestID: 0,
            serviceRequestName: '',
            serviceDetails: [],
            viewGenericDetails: false,
            showWithoutCancelRequest: false,
            quotePrice: "",
            comments: "",
            cancellationRefundPolicy: "Flexible",
            cancellationRefundPolicydropdown: false,
            cancellationRefundPolicydata: [],
            penaltyIdValue: "",
            penaltyDescriptionValue: '',
            loaderTime: false,
            PageDisable: false,
            filePathRespondentTSDocuments: '',
            hasOpenSuccess: false,
            cancelRequest: true,
            showOnlyUpperCard: true,
            serviceStartTime: '',
            hasOpenRating: false,
            ratingStar: '',
            errorStarReason: "",
            reasonTextLimit: 0,
            errors: {},
            errorsQuotePrice: {},
            hasOPenReject: false,
            cancelreason: '',
            cancelreasonTextLimit: 0,
            hasOpen: false,
            hasOpenAlreadyBid: false
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        const { type, serviceRequestId, serviceName } = this.props.match.params;
        console.log('Hiiiii------', serviceRequestId, serviceName);
        this.setState({
            serviceRequestID: serviceRequestId,
            serviceRequestName: serviceName
        })

        if (type == "History") {
            //set false to show cancel request link
            this.setState({
                showWithoutCancelRequest: false,
                showOnlyUpperCard: false
            })
        } else if (type == "Request") {
            if (this.props.history.location.state?.cancellationPolicyFilter) {
                this.setState({
                    cancellationRefundPolicy: this.props.history.location.state?.cancellationPolicyFilter
                });
            }
            this.setState({
                showWithoutCancelRequest: true,
                showOnlyUpperCard: false
            })

        }
        //fetch service details
        this.getRequestDetails(serviceRequestId, type);

    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ cancellationRefundPolicydropdown: false });
        }
    };
    getCancellationPolicyData = () => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_CANCELLATION_POLICY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    this.setState({
                        cancellationRefundPolicydata: apiData,
                    })
                    apiData?.every((md, index) => {
                        if (this.state.cancellationRefundPolicy == md?.basePenalty?.penaltyName) {
                            this.setState({
                                penaltyIdValue: md?.penaltyId,
                                penaltyDescriptionValue: md?.basePenalty?.penaltyDescription
                            })
                            return false
                        }
                        return true
                    })
                }
            }
        });
    }
    toggleDropdowncancellationRefundPolicy = () => {
        this.setState({
            cancellationRefundPolicydropdown: !this.state.cancellationRefundPolicydropdown
        });
    };
    changeRoleTypecancellationRefundPolicy = (event) => {
        const found = this.state.cancellationRefundPolicydata.find((name) => {
            if (name.basePenalty.penaltyName === event.target.innerText) {
                return name
            }
        })
        this.setState({
            cancellationRefundPolicy: found.basePenalty.penaltyName,
            penaltyIdValue: found.penaltyId,
            penaltyDescriptionValue: found.basePenalty.penaltyDescription
        });
        this.setState({ cancellationRefundPolicydropdown: !this.state.cancellationRefundPolicydropdown });
    }
    getRequestDetails = (serviceId, typeValue) => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT + `?roleType=${this.props.manageProfileDataR?.selectedProfileType}&serviceRequestId=${serviceId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("in 500");
                    this.setState({ hasOpenAlreadyBid: true });
                }
                else {
                    if (typeValue == "History") {
                        this.setState({ cancellationRefundPolicy: data?.respondents?.otherRespondents[0]?.cancellationPolicy })
                    }
                    this.setState({
                        serviceDetails: data,
                        serviceStartTime: data?.requestSummary?.serviceDetail?.startDateTime,
                    }, () => {
                        this.setState({
                            viewGenericDetails: true
                        })
                        this.getCancellationPolicyData();
                    })
                }
            }
        });
    }
    handleStartService = () => {
        this.setState({ hasOpenRating: true });
    }
    handleSubmitQuotation = () => {
        if (this.handleQuotePriceValidation()) {
            ApiCall(
                'POST',
                serviceBaseURL + SERVICE_BIDQUOTE_ENDPOINT,
                {
                    "bidDocPath": this.state.filePathRespondentTSDocuments,
                    "comments": this.state.comments,
                    "cancellationPolicy": this.state.penaltyIdValue,
                    "quotePrice": parseInt(this.state.quotePrice),
                    "serviceName": 0,
                    "serviceRequestId": parseInt(this.state.serviceRequestID)
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        this.setState({ hasOpenSuccess: true });
                    }
                }
                else {
                    console.log('Something went wrong!');
                }
            });
        }
    }
    handleQuotePriceValidation = () => {
        let errorsQuotePrice = {};
        let formIsValid = true;
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        if (!this.state.quotePrice) {
            formIsValid = false;
            errorsQuotePrice["quotePrice"] = Message.validation.required;
            document.getElementsByName('QuotePrice')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.quotePrice)) {
            formIsValid = false;
            errorsQuotePrice["quotePrice"] = Message.validation.num;
            document.getElementsByName('QuotePrice')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('QuotePrice')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errorsQuotePrice: errorsQuotePrice });
        return formIsValid;
    }
    handleContinue = () => {
    }
    handleChangeQuotePrice = (e) => {
        this.setState({ quotePrice: e.target.value });
        this.setState({
            errorsQuotePrice: {
                ...this.state.errorsQuotePrice,
                quotePrice: ''
            }
        });
        document.getElementsByName('QuotePrice')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeComments = (e) => {
        this.setState({ comments: e.target.value });
    }
    uploadFileFunction = (uploadConfirm) => {
    }
    removeRespondentTSDocumentsLink = () => {
        let path = "";
        this.setState({ filePathRespondentTSDocuments: path });
    }
    setLoaderRespondentTSDocuments = (filePathURL) => {
        this.setState({ loaderTime: filePathURL });
        this.setState({ PageDisable: filePathURL });
    }
    setUploadLinkRespondentTSDocuments = (filePathURL) => {
        // for loader end
        this.setState({ filePathRespondentTSDocuments: filePathURL });
        this.setState({ loaderTime: false });
        this.setState({ PageDisable: false });
    }
    onCloseModal = () => {
        this.setState({ hasOpen: false });
        // this.props.history.push('/home');
    };
    onCloseAlreadyBid = () => {
        this.setState({ hasOpenAlreadyBid: false });
        this.props.history.push('/ServiceRequest');
    };
    handleChangeComment = (e) => {
        if (e.target.value.length <= 50) {
            this.setState({ reasonTextLimit: e.target.value.length });
            this.setState({ reason: e.target.value });
            this.setState({
                errors: {
                    ...this.state.errors,
                    Comment: ''
                }
            });
            document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    updateRating = (index) => {
        this.setState({ ratingStar: index + 1 });
        this.setState({ errorStarReason: '' });
    }
    onSumbitRating = () => {
        if (this.handleValidationModel()) {
            document.documentElement.scrollTop = 0;
            this.setState({ hasOpenRating: false });
        }
    };
    handleValidationModel = () => {
        let errorStarReason = '';
        let errors = {};
        let formIsValid = true;
        if (this.state.hasOpenRating == true) {
            if (!this.state.ratingStar) {
                formIsValid = false;
                errorStarReason = Message.validation.rating;
            }
            if (!this.state.reason) {
                errors["Comment"] = Message.validation.required;
                document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        this.setState({ errors: errors });
        this.setState({ errorStarReason: errorStarReason })
        return formIsValid;
    }
    handleCancelRequest = () => {
        this.setState({ hasOPenReject: true });
    }
    onCloseReject = () => {
        let errors = {};
        if (!this.state.cancelreason) {
            errors["CancelRejectComment"] = Message.validation.required;
            document.getElementsByName('CancelRejectComment')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('CancelRejectComment')[0].style.borderColor = ColorCode.colorCode.black;
            this.setState({ hasOPenReject: false });
        }
        this.setState({ errors: errors });
    };
    handleChangeCancelComment = (e) => {
        if (e.target.value.length <= 50) {
            this.setState({ cancelreasonTextLimit: e.target.value.length });
            this.setState({ cancelreason: e.target.value });
            this.setState({
                errors: {
                    ...this.state.errors,
                    CancelRejectComment: ''
                }
            });
            document.getElementsByName('CancelRejectComment')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    cancelRequestFunction = () => {
        this.setState({ hasOpen: true });
    }
    onYesModal = () => {
        ApiCall(
            'DELETE',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT + `?serviceRequestNumber=${this.state.serviceRequestID}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    this.setState({ hasOpen: false });
                    this.props.history.push(`/ServiceRequest`)
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    };
    onCloseModalSuccess = () => {
        this.setState({ hasOpen: false });
        this.props.history.push('/');
    };
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.RespondentTransportationServiceGSTitle} description={TitleDescription.RespondentTransportationServiceGSDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullRespondentTransportationService">
                    <div id="csnobox1RespondentTransportationService">
                        <nav class="RespondentTransportationServiceNavBar">
                            <div className="RespondentTransportationServiceNavBarHeading">
                                <small id="RespondentTransportationServiceNavBarHeadingValue">{this.state.serviceRequestName}</small>
                            </div>
                            {!this.state.showWithoutCancelRequest &&
                                <div id="RespondentTransportationServiceAcceptMobile" className="RespondentTransportationServiceNavbarNameRight">
                                    <img src={cancelicon} class=" mr-1 pb-1" id="TransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                    <small
                                        class={this.state.cancelRequest ? "RespondentTransportationServiceNavbarRightText" : "RespondentTransportationServiceNavbarGrayRightText"}
                                        onClick={this.cancelRequestFunction}>
                                        Cancel Request
                                    </small>
                                </div>
                            }
                        </nav>
                        <hr class="hr1" />
                        {!this.state.showWithoutCancelRequest && <>
                            <nav class="RespondentTransportationServiceMobileNavbar">
                                <div className="RespondentTransportationServiceNavbarNameRight">
                                    <img src={cancelicon} class=" mr-1 pb-1" id="TransportationServiceNavBarRightHeadingImg" alt="" loading="lazy" />
                                    <small
                                        class={this.state.cancelRequest ? "RespondentTransportationServiceNavbarRightText" : "RespondentTransportationServiceNavbarGrayRightText"}
                                        onClick={this.cancelRequestFunction}>
                                        Cancel Request
                                    </small>
                                </div>
                            </nav>
                            <hr class="hrRTSMobile" />
                        </>}
                        <div class={this.state.showWithoutCancelRequest ? "toppartRespondentTransportationServiceWOC" : "toppartRespondentTransportationService"}>
                            <div class="TopHeadingRespondentTS">Service Request Details</div>
                            {
                                this.state.showOnlyUpperCard &&
                                <div class="RespTransportationServiceGSDataDiv">
                                    <div class="RespTransportationServiceGSDataInDiv">
                                        <div class="RespTransportationServiceGSDataleftTime">
                                            <img id="RespTransportationServiceGSleftTimeimg" src={pickupTime} />
                                            <text class="RespTransportationServiceGSleftTimeText">Service Start Time</text>
                                        </div>
                                        <div class="RespTransportationServiceGSDataright">
                                            <text class="RespTransportationServiceGSrightTimeText">{FormatTimeStamp(this.state.serviceStartTime).timedateToLocale}</text>
                                        </div>
                                    </div>
                                </div>
                            }
                            {this.state.viewGenericDetails &&
                                <ViewServiceDetailsGS name={this.state.serviceRequestName} data={this.state.serviceDetails} />
                            }
                            {!this.state.showOnlyUpperCard &&
                                <div class="BottomHeadingRespondentTS">Your Response</div>}
                            {this.state.showWithoutCancelRequest ?
                                <div>
                                    {
                                        this.state.showOnlyUpperCard ?
                                            <div class="TransportServiceRBtnDiv">
                                                <Button class="TransportServiceRBtnCss" onClick={this.handleStartService}>
                                                    <small class="TransportServiceRBtntext">Start Service</small>
                                                </Button>
                                            </div>
                                            :
                                            <div>
                                                <div class="TransportationServiceLessRCardcss">
                                                    <div class="RespondentTSRTextInpSize">
                                                        <small id="UpdateServiceRInpHeading">Quote Price (Inclusive of Taxes)</small>
                                                        <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                                            <Input
                                                                name="QuotePrice"
                                                                class="input"
                                                                type="text" id="UpdateServiceRInpCss" value={this.state.quotePrice}
                                                                onChange={this.handleChangeQuotePrice}
                                                            />
                                                            <div className="QuotationDetailsDropError">{this.state.errorsQuotePrice["quotePrice"]}</div>
                                                        </div>
                                                    </div>
                                                    <div class="RespondentTSRTextInpSize">
                                                        <small id="UpdateServiceRInpHeading">Comments (Optional)</small>
                                                        <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                                            <Input
                                                                name="Comments" placeholder="Enter Your Comments"
                                                                class="input"
                                                                type="text" id="UpdateServiceRInpCss" value={this.state.comments}
                                                                onChange={this.handleChangeComments}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="RespondentTSRInpSize">
                                                        <small id="UpdateServiceRInpHeading">Upload Documents (Optional)</small>
                                                        <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                                            <UploadFile uploaddivid="uploadRespondentTSDocuments" idupload="upload"
                                                                name="fileupload"
                                                                fileType="jpeg, jpg, png, pdf"
                                                                setUploadConfirm={this.uploadFileFunction}
                                                                removeLink={this.removeRespondentTSDocumentsLink}
                                                                upload_link="cipcUpload" uploadicon="cipcIcon"
                                                                setFileLink={this.setUploadLinkRespondentTSDocuments}
                                                                setLoader={this.setLoaderRespondentTSDocuments}
                                                                staticFileName={'Response_Documents.'}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="TransportationServiceRInpSize">
                                                        <small class="TransportationServiceResptooltip2" id="TransportationServiceRespInpHeading">
                                                            <div class="TransportationServiceResptooltipouter">
                                                                <span class="TransportationServiceResptooltiptext">
                                                                    <div class="TransportationServiceResptooli01">
                                                                        <div class="TransportationServiceRespTooltipLowerText">{this.state.cancellationRefundPolicy}</div>
                                                                        <small id="TransportationServiceRespTooltipdataHeading">{this.state.penaltyDescriptionValue}</small>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                            Cancellation & Refund Policy
                                                            <img id="TransportationServiceRespInfo_img" src={info_outline} />
                                                        </small>
                                                        <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                                            <Input
                                                                readOnly name="cancellationRefundPolicy" class="input" placeholder="Select"
                                                                type="text" id={this.state.cancellationRefundPolicydropdown ? "TransportServiceBtmBorderLessCss" : "TransportServiceInpDropCss"} value={this.state.cancellationRefundPolicy}
                                                            />
                                                            <i id="TransportServiceInp_imgDrop" onClick={this.toggleDropdowncancellationRefundPolicy}>
                                                                {this.state.cancellationRefundPolicydropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                                            </i>
                                                        </div>
                                                        {this.state.cancellationRefundPolicydropdown && (
                                                            <div class="TransportServiceDropDowmDiv" >
                                                                <div class="TransportServiceDropCard" ref={this.container} >
                                                                    {(this.state.cancellationRefundPolicydata.map((name, index) => {
                                                                        return (
                                                                            <DropDownTable onClick={(val) => this.changeRoleTypecancellationRefundPolicy(val)} id="TransportServiceDropRowSize">
                                                                                <small class="" id="TransportServiceDropRowText" >{name.basePenalty.penaltyName} </small>
                                                                            </DropDownTable>
                                                                        );
                                                                    }))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div class="TransportServiceRBtnDiv">
                                                    <Button class="TransportServiceRBtnCss" onClick={this.handleSubmitQuotation}>
                                                        <small class="TransportServiceRBtntext">Submit Response</small>
                                                    </Button>
                                                </div>
                                            </div>
                                    }
                                </div>
                                :
                                <div>
                                    <div class="TransportationServiceLessRCardcss">
                                        <div class="TransportationServiceRInpSize">
                                            <small id="TransportationServiceRInpHeading">Quote Price (Inclusive of Taxes)</small>
                                            <div class="TransportationServiceRLowerText">{this.state.serviceDetails?.respondents?.otherRespondents[0]?.quotationAmount}</div>
                                        </div>
                                        <div class="TransportationServiceRInpSize">
                                            <small id="TransportationServiceRInpHeading">Comments (Optional)</small>
                                            {(!this.state.serviceDetails?.respondents?.otherRespondents[0]?.comments) ?
                                                <div class="RespondentTSComments">No Comments</div>
                                                :
                                                <div class="TransportationServiceRLowerText">{this.state.serviceDetails?.respondents?.otherRespondents[0]?.comments}</div>
                                            }

                                        </div>
                                        <div class="TransportationServiceRInpSize">
                                            <small id="TransportationServiceRInpHeading">Update Reference Documents (Optional)</small>
                                            {(!this.state.serviceDetails?.respondents?.otherRespondents[0]?.docPath) ?
                                                <div class="TransportationServiceNoDocU">No document uploaded</div>
                                                :
                                                <div class="TransportationServiceRUploaddocText">{this.state.serviceDetails?.respondents?.otherRespondents[0]?.docPath?.split('/')[11]?.split("'")[0]}</div>
                                            }

                                        </div>
                                        <div class="TransportationServiceRInpSize">
                                            <small class="TransportationServiceResptooltip2" id="TransportationServiceRespInpHeading">
                                                <div class="TransportationServiceResptooltipouter">
                                                    <span class="TransportationServiceResptooltiptext">
                                                        <div class="TransportationServiceResptooli01">
                                                            <div class="TransportationServiceRespTooltipLowerText">{this.state.cancellationRefundPolicy}</div>
                                                            <small id="TransportationServiceRespTooltipdataHeading">{this.state.penaltyDescriptionValue}</small>
                                                        </div>
                                                    </span>
                                                </div>
                                                Cancellation & Refund Policy
                                                <img id="TransportationServiceRespInfo_img" src={info_outline} />
                                            </small>
                                            <div class="TransportationServiceRLowerText">{this.state.cancellationRefundPolicy}</div>
                                        </div>
                                    </div>
                                    <div class="TransportServiceRBtnDiv">
                                        <Button class="TransportServiceRBtnCss" onClick={this.handleContinue}>
                                            <small class="TransportServiceRBtntext">Continue</small>
                                        </Button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="cs2footer11RespondentTransportationService">
                    <Footer />
                </div>
                <div class="cs2footer22RespondentTransportationService">
                    <Footer2 />
                </div>
                <SuccessModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModalSuccess}>
                    <div>
                        <div class="successRatingdivout">
                            <small class="successRatingdivsm">Your response has been submitted
                            </small>
                            <small class="successRatingdivsm"> successfully.</small>
                        </div>
                    </div>
                </SuccessModal>
                <StarRatingModal hasOpen={this.state.hasOpenRating} onCloseModal={() => this.onSumbitRating()}>
                    <div class="TSRatingInpModalDivOut">
                        <div class="TSRatingInpModalHeadDiv">
                            <small class="TSRatingInpModalHeadsm">{Message.marketPlace.starRatingModalRateQueryRequester}</small>
                        </div>
                        <div class="TSRatingInpModalLowerSectionDiv">
                            <div class="TSRatingInpModalNameHeadingDiv">
                                <small class="TSRatingInpModalNameHeading">{Message.marketPlace.starRatingModalCompanyName}</small>
                            </div>
                            <div class="TSRatingInpModalImgDiv">
                                <div class="TSRatingInpModalImgDivin">
                                    {[1, 1, 1, 1, 1].map((item, index) => (
                                        <div class="TSRatingInpModalmodalimgposition"
                                            onClick={() => this.updateRating(index)}
                                            key={index}
                                        >
                                            <img src={index < this.state.ratingStar ? bigFilledStar : bigBlankStar} class="TSRatingInpModalImgStar" height="26" width="26" alt="" loading="lazy" />
                                        </div>
                                    ))}
                                </div>
                                <div className="TSRatingInpModalstarunfillerror">{this.state.errorStarReason}</div>
                            </div>
                        </div>
                        <div class="rejectMainDiv" id="TSRatingRejectMainDiv">
                            <div className="pass-wrapper" id="rejectInputDiv" >
                                <Input
                                    name="Comment"
                                    class="input" placeholder="Please enter your comment"
                                    type="text" id="CrtTptReqestInpCss" value={this.state.reason}
                                    onChange={this.handleChangeComment}
                                />
                                <i id="rejectInputIcon">
                                    <img src={edit} />
                                </i>
                                <div className="QuotationDetailsDropError">{this.state.errors["Comment"]}</div>
                                <small class="inpsmallraise">{this.state.reasonTextLimit}/50</small>
                            </div>
                        </div>
                    </div>
                </StarRatingModal>
                {
                    this.state.hasOPenReject ? <GenericReusableModal showImage={true} showImagesrc={alertIcon} hasOpen={this.state.hasOPenReject} onCloseModal={this.onCloseReject} buttonLabel={"Cancel"}>
                        <div>
                            <div class="successtext1outercreatepreadvise">
                                <small class="rejectModalHeading">{Message.marketPlace.RespondentCancelModalHeading}</small>
                            </div>
                            <div class="rejectMainDiv">
                                <div className="pass-wrapper" id="rejectInputDiv" >
                                    <Input
                                        name="CancelRejectComment"
                                        class="input" placeholder="Please enter your reason"
                                        type="text" id="CrtTptReqestInpCss" value={this.state.cancelreason}
                                        onChange={this.handleChangeCancelComment}
                                    />
                                    <i id="rejectInputIcon">
                                        <img src={edit} />
                                    </i>
                                    <div className="QuotationDetailsDropError">{this.state.errors["CancelRejectComment"]}</div>
                                    <small class="inpsmallraise">{this.state.cancelreasonTextLimit}/50</small>
                                </div>
                            </div>
                        </div>
                    </GenericReusableModal> : null
                }
                <CancelModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal} onYesModal={this.onYesModal}>
                    <div>
                        <div class="cancelTransportationServiceDiv">
                            <small class="transportationServiceText">{Message.marketPlace.cancelModalQuery}</small>
                            <small class="transportationServiceTextSmall" id='transportationDesk'>If you have already made the payment the refund</small>
                            <small class="transportationServiceTextSmall" id='transportationDesk'> will be initiated based on the cancellation policy.</small>
                            <small class="transportationServiceTextSmall" id='transportationMobile'>{Message.marketPlace.cancelModalNote}</small>
                        </div>
                    </div>
                </CancelModal>
                <AlreadyBidModal hasOpen={this.state.hasOpenAlreadyBid} onCloseModal={this.onCloseAlreadyBid} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="addprofilemodalsmall">{Message.marketPlace.AlreadyBidModalNote}</small>
                        </div>
                    </div>
                </AlreadyBidModal>
            </div >
        );
    }
}
function mapStateToProps(state) {
    return {
        manageProfileDataR: state.manageProfileReducer.data
    }
}
export default connect(mapStateToProps)(RespondentTransportationServiceGS);